import { createFileRoute } from "@tanstack/react-router";
import { AccessibilityStatementGenerator, type AccessibilityStatementGeneratorRef } from "./components/accessibility-statement-generator";
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { useState, useRef } from "react";

export const Route = createFileRoute("/statement/")({
  component: Statement,
});

function Statement() {
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const generatorRef = useRef<AccessibilityStatementGeneratorRef>(null);

  const handlePreview = async () => {
    if (generatorRef.current) {
      await generatorRef.current.handlePreview();
    }
  };

  return (
    <Card className="cy:rounded-lg cy:gap-0 cy:shadow-none!">
        <CardHeader className="cy:border-b cy:border-gray-200 cy:pb-6">
        <div className="cy:flex cy:items-center cy:justify-between">
          <CardTitle className="cy:text-xl">Statement generator</CardTitle>
          {!showSuccessScreen && (
            <Button
              variant="link"
              size="sm"
              className="cy:flex cy:items-center cy:gap-2 cy:text-primary cy:font-semibold!"
              onClick={handlePreview}
            >
              Preview
              <ExternalLink className="cy:font-semibold!" size={32} strokeWidth={3} />
            </Button>
          )}
        </div>
        <CardAction></CardAction>
      </CardHeader>
      <CardContent className="cy:p-0">
        <AccessibilityStatementGenerator 
          ref={generatorRef}
          onSuccessScreenChange={setShowSuccessScreen} 
        />
      </CardContent>
    </Card>
  );
}
